// Loading splash used during auth bootstrap. Brand-styled.

import { Logo } from './Logo';

export function BrandSplash() {
  return (
    <div className="flex h-full min-h-dvh flex-col items-center justify-center bg-white">
      <Logo height={48} className="mb-6" />
      <div className="h-1 w-32 overflow-hidden rounded-full bg-cloud">
        <div className="h-full w-1/3 animate-pulse rounded-full bg-orange" />
      </div>
    </div>
  );
}
